// Shared footnote fields for all item types
function createFootnoteFields() {
  return {
    footnote_text: "",
    custom_footnote_char: "",
    footnote_on_amount: false,
  };
}

export const Factories = {
  createDvLine(dvKey = "") {
    return {
      name: "",
      amount: "",
      unit: "",
      dv_key: dvKey,
      source: "",
      show_percent: true,
      italicize_parenthetical: false,
      ...createFootnoteFields(),
    };
  },

  createLine() {
    return {
      name: "",
      amount: "",
      unit: "mg",
      source: "",
      no_dv: true,
      italicize_parenthetical: false,
      ...createFootnoteFields(),
    };
  },

  createBlend() {
    // Note: _uid is assigned by ListManager.add(), matching the pattern used by lines
    return {
      name: "",
      amount: "",
      unit: "mg",
      display_mode: "inline",
      italicize_parenthetical: false,
      hide_dagger: false,
      ...createFootnoteFields(),
      constituents: [],
    };
  },

  createConstituent() {
    return {
      name: "",
      amount: "",
      unit: "mg",
      source: "",
      italicize_parenthetical: false,
      hide_dagger: false,
      extra_text: "",
      ...createFootnoteFields(),
    };
  },
};
